import { MenuButton as HeadlessMenuButton } from "@headlessui/react";
import { Button } from "../Button";

export function DropdownButton<T extends React.ElementType = typeof Button>(
  props: React.ComponentProps<typeof HeadlessMenuButton<T>>,
) {
  return <HeadlessMenuButton as={Button} {...props} />;
}
